import React from 'react'
import { Form, Button, Col, Row } from 'react-bootstrap';

import './styles.css'

const PreIngestionFilter = (props) => {
    return (
        <div className="pif-container">
            <div className="pif-content">
                <Form className="regTable-form" onSubmit={props.submitPreIngestion}>

                    <h1 className="regTable-title">Basic information</h1>
                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Type register *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => props.setTypeRegister(e.target.value)} >
                                    <option></option>
                                    <option>Register Table</option>
                                    <option>Register File</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Env *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => props.setEnv(e.target.value)} >
                                    <option></option>
                                    <option>dev</option>
                                    <option>prd</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>layer * </Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => props.setLayer(e.target.value)} >
                                    <option></option>
                                    <option>all</option>
                                    <option>raw</option>
                                    <option>trusted</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={4} />
                    </Row>

                    <div className="pif-btn">
                        <Button variant="primary" type="submit">
                            Pesquisar
                        </Button>
                    </div>

                </Form>
            </div>
        </div>
    );
}

export default PreIngestionFilter;
